import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiListResponse, ApiObjectResponse } from './shared/models/api-response.interface';
import { Geometre } from './citizens/home-pages/citizen-home/models/geometre.interface';

@Injectable({
  providedIn: 'root',
})
export class IpService {
  private ipApiUrl = 'https://api.ipify.org?format=json'; // API de récupération de l'IP

  constructor(private http: HttpClient) {}

  getIpAddress(): Observable<{ ip: string }> {
    return this.http.get<{ ip: string }>(this.ipApiUrl);
  }

  getAllGeo(
    page: number = 0,
    size: number = 10
  ): Observable<ApiObjectResponse<ApiListResponse<Geometre>>> {
    return this.http.get<ApiObjectResponse<ApiListResponse<Geometre>>>(
      `${environment.API_URL}request/geometres?page=${page}&search=`
    );
  }

  searchGeo(
    searchTerm: string,
    page: number = 0,
    size: number = 10
  ): Observable<ApiObjectResponse<ApiListResponse<Geometre>>> {
    return this.http.get<ApiObjectResponse<ApiListResponse<Geometre>>>(
      `${environment.API_URL}request/geometres?page=${page}&search=${encodeURIComponent(searchTerm)}`
    );
  }
}
